/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.CabinMasterResponseDto>>;
export function request(
  params: API.tms.cabinMasterFactoryWhole.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryWhole/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
